"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useAppState = useAppState;
const vue_1 = require("vue");
const core_1 = require("@fiksu/core");
function messagesFor(error) {
    const messages = (0, core_1.extractErrorMessages)(error ?? {});
    return messages.length ? messages : (0, core_1.extractErrorMessages)({});
}
function useAppState() {
    const state = (0, vue_1.ref)('loading');
    const errors = (0, vue_1.ref)([]);
    let latestLoad = 0;
    async function load(task) {
        const thisLoad = ++latestLoad;
        const isLatest = () => thisLoad === latestLoad;
        state.value = 'loading';
        errors.value = [];
        try {
            await task(messages => { if (isLatest())
                fail(messages); });
            if (isLatest() && state.value === 'loading')
                state.value = 'ready';
        }
        catch (error) {
            if (isLatest())
                fail(messagesFor(error));
        }
    }
    function fail(messages) {
        state.value = 'failed';
        errors.value = messages;
    }
    return { state: (0, vue_1.readonly)(state), errors: (0, vue_1.readonly)(errors), load, fail };
}
